import { VITE_FORGE_URL } from '@constants';
import axios from 'axios';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

// Push GTM dataLayer event after a successful Stripe checkout redirect
export function useCheckoutDataLayer() {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		const sessionId = searchParams.get('session_id');
		if (!sessionId) return;

		let cancelled = false;

		(async () => {
			try {
				const { data } = await axios.get(`${VITE_FORGE_URL}/stripe/checkout-result/${sessionId}`, {
					withCredentials: true,
				});
				if (cancelled || !data.event) return;

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push(data);
			} catch (err) {
				console.error('Failed to fetch checkout result for GTM:', err);
			} finally {
				if (!cancelled) {
					// Clean session_id from URL without a navigation
					searchParams.delete('session_id');
					setSearchParams(searchParams, { replace: true });
				}
			}
		})();

		return () => {
			cancelled = true;
		};
	}, [searchParams, setSearchParams]);
}
